import React from 'react';
import classes from './NavItem.css';
import {NavLink} from 'react-router-dom';

const NavItem=(props)=>(
	<li className={classes.Navitem}>
		<NavLink to={props.link} exact activeClassName={classes.active}>
			{props.children}
		</NavLink>
	</li>

	)

export default NavItem;


// WEBPACK FOOTER //
// ./src/components/Navigation/NavItems/NavItem/NavItem.jsx